// extracted by mini-css-extract-plugin
export default {"dropzone":"styles---dropzone---DL64s","leftAlign":"styles---leftAlign---G1no6","dropWrapper":"styles---dropWrapper---yHiwa","dropText":"styles---dropText---m6UEf"};